import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { LineItemRefundStaff } from "./LineItemRefundStaff";
import type { OrderRefundDTOBase } from "./OrderRefundDTOBase";
import type { OrderRefundStatus } from "./OrderRefundStatus";
import type { OrderStaff } from "./OrderStaff";
import type { PaymentRefundStaff } from "./PaymentRefundStaff";
import type { TrackedModernBase } from "./TrackedModernBase";

export class OrderRefundStaff implements OrderRefundDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly refundStatus: OrderRefundStatus, public readonly amountRefundedCents: number, public readonly refundDatetime: Date | null, public readonly reason: string | null, public readonly failureMessage: string | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly orderId: OrderStaff | null, public readonly lineItemRefunds: Array<LineItemRefundStaff> | null, public readonly paymentRefunds: Array<PaymentRefundStaff> | null) {
    this.cbiServiceContext = null;
    this.orderIdLoaded = this.orderId != null;
    this.orderIdCached = this.orderId;
    this.lineItemRefundsLoaded = this.lineItemRefunds != null;
    this.lineItemRefundsCached = this.lineItemRefunds;
    this.paymentRefundsLoaded = this.paymentRefunds != null;
    this.paymentRefundsCached = this.paymentRefunds;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private orderIdLoaded: boolean;
  private orderIdCached: OrderStaff | null;
  private lineItemRefundsLoaded: boolean;
  private lineItemRefundsCached: Array<LineItemRefundStaff> | null;
  private paymentRefundsLoaded: boolean;
  private paymentRefundsCached: Array<PaymentRefundStaff> | null;
  async orderIdLazy(): Promise<OrderStaff> {
    if (!this.orderIdLoaded) {
      this.orderIdCached = await this.cbiServiceContext!.orderRefundService().getOrderRefundStaffOrderId(this.assignId);
      this.orderIdLoaded = true;
    }
    return this.orderIdCached!;
  }
  async lineItemRefundsLazy(): Promise<Array<LineItemRefundStaff>> {
    if (!this.lineItemRefundsLoaded) {
      this.lineItemRefundsCached = await this.cbiServiceContext!.orderRefundService().getOrderRefundStaffLineItemRefunds(this.assignId);
      this.lineItemRefundsLoaded = true;
    }
    return this.lineItemRefundsCached!;
  }
  async paymentRefundsLazy(): Promise<Array<PaymentRefundStaff>> {
    if (!this.paymentRefundsLoaded) {
      this.paymentRefundsCached = await this.cbiServiceContext!.orderRefundService().getOrderRefundStaffPaymentRefunds(this.assignId);
      this.paymentRefundsLoaded = true;
    }
    return this.paymentRefundsCached!;
  }
}
